import { render, staticRenderFns } from "./SAvatar.vue?vue&type=template&id=1e21c80c&"
import script from "./SAvatar.vue?vue&type=script&lang=js&"
export * from "./SAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports